var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-palette"},_vm._l((_vm.colorList),function(c){return _c('div',{key:c,class:_vm.getColorClass(c),style:({ backgroundColor: c }),attrs:{"id":c},on:{"click":function($event){return _vm.selectColor(c)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }